import { forwardRef, Inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ACTION_DEFINITION_TYPES } from '../common/endpoints';
import { ActionDefinitionType } from '../model';
import { HttpService } from './http.service';


@Injectable()
export class ActionDefinitionTypeService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private http: HttpService
    ) { }

    getAllActionDefinitionTypes(): Promise<ActionDefinitionType[]> {
        return firstValueFrom(this.http.get<ActionDefinitionType[]>(ACTION_DEFINITION_TYPES));
    }

}